import BookIndex from "components/shared/book/list";
import SharedReactTable from "components/shared/reactTable";
import { organizationFlags, organizationFlagsEnum } from "helpers/enums";
import { paths } from "helpers/paths";
import { BooleanColumnFilter, rowIndexColumn } from "helpers/reactTable";
import { tableContainer } from "helpers/redux";
import { flagVal } from "helpers/system";
import React from "react";
import { Link } from "react-router-dom";
import UsersGroupForm from "./form";

const hiddenDirectionFlagVal = flagVal(organizationFlags, organizationFlagsEnum.HiddenDirection);

class UsersGroupsList extends BookIndex {
    get tableColumns() {
        this.hiddenDirection = (this.props.organization.intFlags & hiddenDirectionFlagVal) === hiddenDirectionFlagVal;
        const hiddenDirectionColumn = {
            Header: "Скрытое направление",
            accessor: "hiddenDirection",
            width: 150,
            sortable: true,
            filterable: true,
            filterType: "boolean",
            Filter: (props) => {
                const defaultValue = { id: "isDeleted", value: "false", filterType: "boolean" };
                const options = [
                    { label: "Показать все направления", value: "all" },
                    { label: "Только скрытые направления", value: "true" },
                    { label: "Только открытые направления", value: "false" },
                ];
                return <BooleanColumnFilter {...props} options={options} defaultValue={defaultValue} />;
            },
            Cell: ({ value }) => <div className="text-center">{value ? "Да" : "Нет"}</div>,
            CSVExport: ({ value }) => (value ? "Да" : "Нет"),
        };
        const columns = [
            rowIndexColumn,
            { Header: "ID", accessor: "id", width: 100, filterable: true, filterType: "int" },
            {
                Header: "Название",
                accessor: "name",
                filterable: true,
                Cell: ({
                    value,
                    row: {
                        original: { id },
                    },
                }) => <Link to={paths.usersGroupsShow(id)}>{value}</Link>,
            },
            {
                Header: "Скрыта в планировании",
                accessor: "hiddenInPlanning",
                width: 150,
                sortable: true,
                filterable: true,
                filterType: "boolean",
                Filter: (props) => {
                    const defaultValue = { id: "hiddenInPlanning", value: "all", filterType: "boolean" };
                    const options = [
                        { label: "Показать все", value: "all" },
                        { label: "Только скрытые", value: "true" },
                        { label: "Только открытые", value: "false" },
                    ];
                    return <BooleanColumnFilter {...props} options={options} defaultValue={defaultValue} />;
                },
                Cell: ({ value }) => <div className="text-center">{value ? "Да" : "Нет"}</div>,
                CSVExport: ({ value }) => (value ? "Да" : "Нет"),
            },
        ];

        return this.hiddenDirection ? [...columns, hiddenDirectionColumn] : columns;
    }

    renderCreateButton = () => {
        const { modal, createBtnText, mergeParams } = this.props;
        const action = () =>
            modal({
                name: "default",
                windowMod: "wide",
                title: "Создание группы",
                CustomBody: UsersGroupForm,
                bodyData: { mergeParams, hiddenDirection: this.hiddenDirection },
            });
        return (
            <a className="btn btn-brand btn-sm" onClick={action}>
                {createBtnText}
            </a>
        );
    };

    renderHead = () => {
        return (
            <div className="book-list__head-wrap">
                <div className="book-list__head">
                    <div className="book-list__head-close close close--sm" onClick={this.close} />
                    <div className="book-list__head-title">
                        {this.props.title}
                        {this.renderCounter()}
                    </div>
                    <div className="btn-toolbar">
                        {this.props.roles.isTruckingOrganizationAdmin && (
                            <Link className="btn btn-secondary btn-sm mr-2" to={paths.usersGroupsCars}>
                                Управление машинами в группах
                            </Link>
                        )}
                        {this.props.canEditBooks && this.renderCreateButton()}
                    </div>
                </div>
            </div>
        );
    };

    renderListComponent = () => <SharedReactTable {...this.props} columns={this.state.tableColumns} />;
}

export default tableContainer(UsersGroupsList, "users-groups");
